import Vue from 'vue'
import Vuex from 'vuex'
import {shared} from './modules/shared'
import hazards from "./modules/hazards";
import incidents from "./modules/incidents";
import terroristGroups from "./modules/terroristGroups";
import form from "./modules/form";
import user from "./modules/user";
import contributor from "./modules/contributor";
import contribution from "./modules/contribution";
import search from "./modules/search";
import adverts from "./modules/adverts";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        shared: shared,
        hazards: hazards,
        incidents: incidents,
        terroristGroups: terroristGroups,
        form: form,
        user: user,
        contributor: contributor,
        contribution: contribution,
        search: search,
        adverts: adverts,
    }
});



// WEBPACK FOOTER //
// ./resources/js/store/index.js